var _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgOrderDots(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 15,
    viewBox: "0 0 24 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.33326 12.3335C5.33326 10.8607 4.13949 9.66674 2.66674 9.66674C1.194 9.66674 0 10.8607 0 12.3335C0 13.8062 1.194 15 2.66674 15C4.13949 15 5.33326 13.8062 5.33326 12.3335Z",
    fill: "#A0AEC0"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14.667 12.3335C14.667 10.8607 13.473 9.66674 12.0002 9.66674C10.5275 9.66674 9.3335 10.8607 9.3335 12.3335C9.3335 13.8062 10.5275 15 12.0002 15C13.473 15 14.667 13.8062 14.667 12.3335Z",
    fill: "#A0AEC0"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M21.333 9.66674C22.8058 9.66674 23.9998 10.8607 23.9998 12.3335C23.9998 13.8062 22.8058 15 21.333 15C19.8603 15 18.6665 13.8062 18.6665 12.3335C18.6665 10.8607 19.8603 9.66674 21.333 9.66674Z",
    fill: "#A0AEC0"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M5.33326 3.00025C5.33326 1.52751 4.13949 0.333734 2.66674 0.333734C1.194 0.333734 0 1.52751 0 3.00025C0 4.47299 1.194 5.66699 2.66674 5.66699C4.13949 5.66699 5.33326 4.47299 5.33326 3.00025Z",
    fill: "#A0AEC0"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M12.0002 0.333734C13.473 0.333734 14.667 1.52751 14.667 3.00025C14.667 4.47299 13.473 5.66699 12.0002 5.66699C10.5275 5.66699 9.3335 4.47299 9.3335 3.00025C9.3335 1.52751 10.5275 0.333734 12.0002 0.333734Z",
    fill: "#A0AEC0"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M23.9998 3.00025C23.9998 1.52751 22.8058 0.333734 21.333 0.333734C19.8603 0.333734 18.6665 1.52751 18.6665 3.00025C18.6665 4.47299 19.8603 5.66699 21.333 5.66699C22.8058 5.66699 23.9998 4.47299 23.9998 3.00025Z",
    fill: "#A0AEC0"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOrderDots);
export default __webpack_public_path__ + "static/media/orderDots.323c29170618b67af1178e2ab71038ff.svg";
export { ForwardRef as ReactComponent };